/* ==========================================================================
   Ryse - Theoric: os cards de categoria dentro do modal de busca

   Romulo, 12/07/2026.
   Quando a busca abre e o campo esta VAZIO, o painel mostra tres cards -
   Haircare, Skincare, Bodycare - com a foto da colecao. E o estado de "nao sei
   o que procurar": em vez de um campo vazio encarando o cliente, tres caminhos.

   >>> O HTML VEM DO LIQUID, NAO DAQUI <<<
   sections/theoric-busca-categorias.liquid le collections[handle].image NA HORA.
   Se a foto da colecao mudar no admin, o card muda sozinho. Chumbar a URL da
   imagem aqui seria criar uma mentira com data para vencer.

   >>> ARMADILHA JA PAGA (a mesma do carrossel do carrinho) <<<
   A Section Rendering API ENVELOPA a resposta num <div id="shopify-section-...">.
   Procurar pelo id do elemento interno devolve null e o codigo sai em silencio -
   sem erro, sem nada na tela. Por isso procuramos pelo data-attribute.

   >>> BUSCA UMA VEZ SO <<<
   O painel abre e fecha o tempo todo. O cache guarda o html; a segunda abertura
   nao toca a rede. E se a requisicao falhar, a BUSCA CONTINUA FUNCIONANDO - os
   cards sao um bonus, nao um requisito. Nunca deixe um enfeite derrubar a
   funcao.

   >>> QUEM ESCONDE OS CARDS QUANDO O CLIENTE DIGITA E O CSS, NAO O JS <<<
   .search-modal:has(input:not(:placeholder-shown)) .theoric-busca-cats { none }
   Um estado a menos para o JS sincronizar - e sem risco de os cards ficarem
   presos na tela por cima dos resultados.
   ========================================================================== */
(function () {
  'use strict';

  var SECAO = 'theoric-busca-categorias';

  var cacheHtml = null;
  var buscando = false;

  function modal() {
    return document.querySelector('.header__search .search-modal');
  }

  function jaEstaLa() {
    var m = modal();
    return !!(m && m.querySelector('[data-theoric-busca-cats]'));
  }

  function colocar(html) {
    var m = modal();
    if (!m || jaEstaLa()) return;

    var temp = document.createElement('div');
    temp.innerHTML = html;

    // pelo data-attribute: a API envelopa em #shopify-section-... (ver o topo)
    var bloco = temp.querySelector('[data-theoric-busca-cats]');
    if (!bloco) return;

    m.appendChild(bloco);
  }

  function carregar() {
    if (jaEstaLa()) return;

    if (cacheHtml) {
      colocar(cacheHtml);
      return;
    }

    if (buscando) return;
    buscando = true;

    fetch('/?section_id=' + SECAO)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        cacheHtml = html;
        colocar(html);
      })
      .catch(function (erro) {
        console.warn('[theoric-header-busca] os cards de categoria nao carregaram. A busca segue normal.', erro);
      })
      .finally(function () { buscando = false; });
  }

  function ligar() {
    var det = document.querySelector('.header__search details');
    if (!det || det.dataset.theoricBusca === 'on') return;
    det.dataset.theoricBusca = 'on';

    // o <details> avisa sozinho quando abre - nao precisamos vigiar clique
    det.addEventListener('toggle', function () {
      if (det.open) carregar();
    });

    if (det.open) carregar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }

  // o editor de tema redesenha a secao do header: religamos
  document.addEventListener('shopify:section:load', ligar);
})();
